<template>
    <div style="min-width:1200px;margin:0 auto;">
        <personal-header :configData="configData"></personal-header>
        <div style="width: 100%;;background: #f4f4f4;">
            <div style="display: flex;width: 1240px;min-height:900px;margin: 0 auto;" id="person">
                <left-nav style="margin-right: 20px;"></left-nav>
                <div style="display:flex;flex-direction: column;flex:1;margin: 0 0 5px 190px;position:relative;background:white;">
                    <div id="warningTime">
                        <div
                            v-if="msg && (availableTime >= lastDay(userInfo.availableTime)) && lastDay(userInfo.availableTime) !== 0"
                            style="display:flex;background:#FFF3F3;color:#999999;flex-direction:row;align-items: center;border-radius:5px;position:absolute;top:1px;left:0;width:100%;
                            position:absolute;width:1080px;"
                        >
                            <img src="@/assets/bugle.png" alt style="width:18px;margin-right:18px" />
                            <span style="flex:1;color:#F53A36;padding-left:10px">您的管制员英语等级证书即将到期，请做好报考准备!</span>
                            <i class="el-icon-close" style="cursor: pointer" @click="msg = false"></i>
                            <!-- <img src="../../../assets/guanbi.png" style="width:16px" @click="msg = false" /> -->
                        </div>
                        <div
                            v-if="msg && lastDay(userInfo.availableTime) == 0"
                            style="display:flex;background:#FFF3F3;color:#999999;flex-direction:row;align-items: center;border-radius:5px;position:absolute;top:1px;left:0;width:100%;"
                        >
                            <img src="@/assets/bugle.png" alt style="width:18px;margin-right:18px" />
                            <span style="flex:1;color:#F53A36;padding-left:10px">您的管制员英语等级证书已过期!</span>
                            <i class="el-icon-close" style="cursor: pointer" @click="msg = false"></i>
                            <!-- <img src="../../../assets/guanbi.png" style="width:16px" @click="msg = false" /> -->
                        </div>
                    </div>
                    <router-view></router-view>
                </div>
            </div>
        </div>
        <footer-vue :configData="configData"></footer-vue>
    </div>
</template>
<script>
import LeftNav from "./leftNav"
import FooterVue from "../../FooterVue"
import PersonalHeader from "./personalCenterHead"
export default {
    components: {
        LeftNav,
        FooterVue,
        PersonalHeader
    },
    data () {
        return {
            activeIndex: "1",
            configData: "",
            msg: true,
            availableTime: 60,
            userInfo: {}
        }
    },
    methods: {
        incrementTotal (val) {
            this.activeIndex = val
            console.log(val)
        },
        // 获取全局配置信息
        getConfig () {
            this.$ajax
                .post(this.pathUrl("/globleWeb/getSysSetList"), this.postData({}))
                .then(res => {
                    this.configData = res.data[0]
                    // document.title = res.data[0].webname;
                })
        },
        setInfo (data) {
            console.log('qqqqqqqqqqq', data)
            if (data.type === 1) {

                this.availableTime = data.availableTime
            } else {

                this.userInfo = data.userInfo
            }
        },
        lastDay (time) {
            const nowTime = new Date()
            const lastTime = new Date(time)
            const day = (lastTime.getTime() - nowTime.getTime()) / (1000 * 60 * 60 * 24)
            // debugger
            console.log('111111')
            console.log(lastTime.getTime())
            console.log(nowTime.getTime())
            console.log(time)
            console.log(day)
            if (day > 0) {
                return Number.parseInt(day) + 1
            } else {
                return 0
            }
        },
        async getAvailableTime () {
            const res = await this.$ajax.post("/auth-config-service/dict/getAvailableTime")
            // debugger
            this.availableTime = res.data ? Number.parseInt(res.data) : 60
        },
        warningClose() {
            setInterval(() => {
                document.getElementById('warningTime').style.display = 'none'
            }, 5000)
        }
    },
    created () {
        this.getConfig()
        this.warningClose()
    },
    mounted () {
        this.$ajax.post("/comuser-service/Account/seeAccount", this.postData({
            id: sessionStorage.userUuid
        })).then(res => {
            // debugger
            this.userInfo = res.data.tbAccount
        })
        this.getAvailableTime()
    },
};
</script>
<style lang="scss">
#person {
    top: 0;
    .content {
        // width: 1200px;
        min-height: 400px;
    }
}
</style>




// WEBPACK FOOTER //
// src/views/trainClass/personalCenter/app.vue